import { features } from '@/mocks/common';

export default function FeaturesSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择 bob体育
          </h2>
          <p className="text-sm text-foreground-500 mt-2">专业、安全、便捷，值得信赖的体育娱乐平台</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70 group hover:border-accent-200 transition-colors"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1">{feature.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}